import { Box, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { LINDA_MAMA_ID, NHIF } from "../../InsurerAccordion/formConstants";
import { OUTPATIENT } from "../formConstants";

const useStyles = makeStyles((theme) => ({
  facility: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  insurer: {
    fontSize: 20,
    fontWeight: 700,
  },
  label: {
    fontSize: 12,
    fontWeight: 700,
  },
  facilityInfo: {
    fontSize: 12,
  },
  invoiceInfo: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: "flex",
    flexDirection: "row",
    margin: `${theme.spacing(3)}px 0`,
  },

  wrapper: {
    display: "inline-block",
    width: "70%",
    verticalAlign: "top",
  },
  insurerWrapper: {
    display: "inline-block",
    verticalAlign: "top",
    width: "30%",
    textAlign: "right",
  },

  paragraph: {
    fontSize: 14,
    padding: `${theme.spacing(0.5)}px 0`,
  },
  invoiceContainer: {
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing(0.5)}px 0`,
  },
  invoiceType: {
    fontSize: 16,
    fontWeight: 700,
    marginRight: theme.spacing(1),
  },
  invoiceNumber: {
    fontSize: 18,
    fontWeight: 700,
  },
  outpatient: {
    fontSize: 14,
    display: "flex",
    marginTop: theme.spacing(1),
  },
  visitDate: {
    fontSize: 14,
    display: "flex",
    marginBottom: theme.spacing(2),
  },
}));

const HeaderTitle = ({ insurer }) => {
  if (insurer.name === NHIF) {
    return "NHIF";
  }
  return insurer.name === LINDA_MAMA_ID
    ? "Linda Mama"
    : insurer?.insuranceDetails?.name || insurer.name;
};

const InsuranceHeader = ({ insurer, invoice }) => {
  const { invoiceNumber, patientType = "Outpatient", facility } = invoice;
  const classes = useStyles();
  const address = facility?.addresses?.[0] ?? {};
  const street = address?.street ? `${address?.street}, ` : "";
  const ward = address?.ward ? address?.ward : "";
  const subCounty = address?.subCounty ? ` ${address?.subCounty}, ` : "";
  const formattedAddress = street + ward + subCounty + address?.state;
  return (
    <Box>
      <Box>
        <Box className={classes.wrapper}>
          <div>
            <Typography className={classes.facility}>
              {facility?.name}
            </Typography>
          </div>
          <div>
            <span className={classes.label}>
              <FormattedMessage
                id="printableInvoice.insurer.address"
                defaultMessage="Address:"
              />
            </span>
            <span className={classes.facilityInfo}>{formattedAddress}</span>
          </div>
        </Box>
        <Box className={classes.insurerWrapper}>
          <Typography className={classes.insurer}>
            <HeaderTitle insurer={insurer} />
          </Typography>
        </Box>
      </Box>
      <Box className={classes.invoiceInfo}>
        <Typography className={classes.invoiceType}>
          {patientType === OUTPATIENT ? "OUTPATIENT" : "INPATIENT"}
        </Typography>
        <Typography className={classes.invoiceType}>
          <FormattedMessage
            id="printableInvoice.insurer.invoice"
            defaultMessage="INVOICE"
          />
        </Typography>
        <Typography
          className={classes.invoiceNumber}
        >{` ${invoiceNumber}`}</Typography>
      </Box>
    </Box>
  );
};

InsuranceHeader.propTypes = {
  invoice: PropTypes.shape({
    invoiceNumber: PropTypes.string,
    created: PropTypes.string,
    patientType: PropTypes.string,
    inpatientDetails: PropTypes.shape({
      inpatientNumber: PropTypes.string,
      admission: PropTypes.string,
      discharge: PropTypes.string,
    }),
  }).isRequired,
  insurer: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};

export default InsuranceHeader;
